import styled from "styled-components";
import { MainCorrect, MainDashedInput, MainFrame, MainFrameImage, MainFrameWrapper, MainHeadingColor, MainQuestion, MainSection, MainSentenceWrapper } from "../../../components/01_config/MainStyles";
import { sizes } from "../../../components/01_config/Sizes";
import { colors } from "../../../components/01_config/Colors";

const Wrapper = styled.div`
    margin-top: ${sizes.headerheight};
`

const Header = styled.div`
    position: relative;
    padding: 50px;
    background-color: ${colors.reading};
    color: white;
    font-size: 3rem;
    font-weight: bold;
    text-transform: uppercase;
    @media(max-width: 800px) {
        padding: 30px 0;
        text-align: center;
        font-size: 2rem
    }
`

const TextsSection = styled(MainSection)`
    flex-direction: column;
    scroll-margin-top: ${sizes.headerheight}; 
`

const FrameWrapper = styled(MainFrameWrapper)`

`

const HeadingColor = styled(MainHeadingColor)`
    text-align: center;
`

const FrameReadingLeft = styled(MainFrame)`
    position: relative;
    min-height: 100%;
`

const ImageWrapper = styled.div`
    width: 100%;
    height: 100%;
`
const FrameReadingRight = styled(MainFrameImage)`
`

const RightFrameWrapper = styled.div`
    width: 400px;
    max-height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`

const Image = styled.img`
    height: 300px;
    object-fit: cover;
    width: 100%;
`

// const Text = styled.div`
//     font-size: 1.4rem;
//     text-wrap: nowrap;
//     line-height: 1.6;
//     -webkit-tap-highlight-color: transparent;
// `

const TextReading = styled.div`
    position: relative;
    height: 100%;
    white-space: pre-wrap;
    font-size: 1.2rem;
    line-height: 2;
    -webkit-tap-highlight-color: transparent;
    width: 100%;
`

const SentenceWrapper = styled(MainSentenceWrapper)`
    text-align: center;
`

const Question = styled(MainQuestion)`
    white-space: pre-wrap;
    line-height: 1.1;
`

const ReadingInput = styled(MainDashedInput)`
    margin: 0 auto;
`

const Correct = styled(MainCorrect)`
    color: red;
    font-size: 1rem;
    line-height: 1;
`

export { Wrapper, Header, TextsSection, FrameWrapper, HeadingColor, FrameReadingLeft, FrameReadingRight, RightFrameWrapper, ImageWrapper, Image, TextReading, SentenceWrapper, Question, Correct, ReadingInput }